export default "__VITE_ASSET__CNcDZgqe__"